module.exports = __webpack_public_path__ + "static/img/图片14.74924a27.png";